export default __webpack_public_path__ + "static/media/logoX.7e963675.svg";